import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { SnapshotAlarm } from 'types';

export const deleteAlarm = (alarmId: number) => {
  return axios.delete(`/api/snapshots/alarms/${alarmId}`);
};

type UseDeleteAlarmOptions = {
  config?: MutationConfig<typeof deleteAlarm>;
};

export const useDeleteAlarm = ({ config }: UseDeleteAlarmOptions) => {
  return useMutation({
    onMutate: async (deletedAlarmId: number) => {
      await queryClient.cancelQueries(['alarms']);

      const previousAlarms = queryClient.getQueryData<SnapshotAlarm[]>([
        'alarms',
      ]);

      queryClient.setQueryData(
        ['alarms'],
        previousAlarms?.filter((alarm) => alarm.id !== deletedAlarmId)
      );

      return { previousAlarms };
    },
    onError: (_, __, context: any) => {
      if (context?.previousAlarms) {
        queryClient.setQueryData(['alarms'], context.previousAlarms);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['alarms']);
    },
    ...config,
    mutationFn: deleteAlarm,
  });
};
